import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { canAcknowledge, canDisplayDetail } from 'state/blotters/priceImprovement/priceImprovementBlotter.selector';
import type { AppState } from 'state/state.model';

interface StateProps {
  isBlotterPanelActive: boolean;
  canAcknowledge: boolean;
}
export type PriceImprovementBlotterProps = StateProps;

const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (appState: AppState): StateProps => ({
  canAcknowledge: canAcknowledge(appState),
  isBlotterPanelActive: canDisplayDetail(appState),
});

export const connectPriceImprovementBlotter = connect(mapStateToProps);
